import { render, staticRenderFns } from "./SampleModalKanbanTaskEmpty.vue?vue&type=template&id=1ffd0d8e&scoped=true&"
import script from "./SampleModalKanbanTaskEmpty.vue?vue&type=script&lang=js&"
export * from "./SampleModalKanbanTaskEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd0d8e",
  null
  
)

export default component.exports